module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Edition du formulaire VE","titleForm":"Visite d\u0027Entretien - Dossier N°{folderNumber}","attachementTitle":"Liste des pièces jointes","submit":"Enregistrer","submitForValidation":"Enregistrer pour validation","cancel":"Retour","processing":"Traitement en cours...","resultComment":"Commentaire"}}')
  delete Component.options._Ctor
}
